import React, { useCallback, useEffect, useRef, useState } from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";
import { VisualCarouselComponent } from "../../../components/VisualCarouselComponent/VisualCarouselComponent";
import { nonEmptyArray } from "fp-ts";
import { pipe } from "fp-ts/lib/function";

export const ProductListingPageFamiliesCarousel: ReactTFC<{
  familiesCarousel: NonEmptyArray<{
    backgroundImage: { url: string; title: string | undefined; sys: { id: string } };
    headline: string;
    link: string;
    buttonLabel: string;
  }>;
}> = props => {
  return (
    <VisualCarouselComponent
      elements={pipe(
        props.familiesCarousel,
        nonEmptyArray.map(el => {
          return {
            key: el.backgroundImage.url,
            headline: el.headline,
            backgroundImage: el.backgroundImage,
            buttons: nonEmptyArray.of({
              label: el.buttonLabel,
              link: el.link,
              isInternal: true,
              type: "Internal Link",
              data: {
                pathname: el.link,
                search: undefined,
              },
            }),
          };
        }),
      )}
      autoSlideMs={undefined}
    />
  );
};
